export function useCarousel({
  wrapElem,
  isLoop = false,
}: {
  wrapElem: any;
  isLoop?: boolean;
}) {
  //console.log(scrollend)
  const options = {
    root: wrapElem,
    rootMargin: '0px',
    threshold: 0.9,
  };
  const intersectionCallback = (entries: any) => {
    entries.forEach((entry: any) => {
      const elem = entry.target;
      elem.setAttribute('data-visible', entry.isIntersecting);
      elem.style['scroll-snap-align'] = 'start';
      elem.style['box-sizing'] = 'content-box';

      if (!visibleSlides.all().length) return;
      setCurrentElement(visibleSlides.first());
      _data.isFirstSlide = visibleSlides.first() === wrapElem.children[0];
      if (!_data.isLastSlide) {
        _data.isLastSlide =
          visibleSlides.last() ===
            wrapElem.children[wrapElem.children.length - 1] && !isLoop;
      }
    });
  };

  const observer = new IntersectionObserver(intersectionCallback, options);
  for (const elem of wrapElem.children) observer.observe(elem);

  const _data = {
    currentSlide: {
      index: 0,
      el: wrapElem.children[0],
    },
    isFirstSlide: true,
    isLastSlide: wrapElem.scrollWidth <= wrapElem.clientWidth,
  };

  const visibleSlides = {
    all: () => wrapElem.querySelectorAll('[data-visible="true"]'),
    first: () => visibleSlides.all()[0],
    last: () => visibleSlides.all()[visibleSlides.all().length - 1],
    beforeFirst: () => visibleSlides.first()?.previousElementSibling,
    afterLast: () => visibleSlides.last()?.nextElementSibling,
    next: () => visibleSlides.first()?.nextElementSibling,
  };

  const setCurrentElement = (elem: Element) => {
    const nodes = Array.prototype.slice.call(wrapElem.children);
    _data.currentSlide.el = elem;
    _data.currentSlide.index = nodes.indexOf(elem);
  };

  wrapElem.addEventListener('scrollend', (event: any) => {});
  const scrollTo = (domElem: HTMLElement) => {
    if (!domElem) return;
    wrapElem.scrollTo({
      left: domElem.offsetLeft,
      behavior: 'smooth',
    });
  };
  const nextSlide = () => {
    if (
      isLoop &&
      visibleSlides.last() === wrapElem.children[wrapElem.children.length - 1]
    ) {
      scrollTo(wrapElem.children[0]);
      return;
    }
    if (!_data.isLastSlide) {
      scrollTo(visibleSlides.next())
      return;
    }
    if (_data.currentSlide.index+1 <= wrapElem.children.length-1) {
      scrollTo(wrapElem.children[_data.currentSlide.index+1])
    }
  };
  
  const toSlide = (slideIndex: number) => {
    if (slideIndex >= 0 && slideIndex <= wrapElem.children.length - 1) {
      scrollTo(wrapElem.children[slideIndex]);
    }
  }

  const prevSlide = () => {
    if (!_data.isFirstSlide) scrollTo(visibleSlides.beforeFirst());
  };

  return {
    navigate: {
      prevSlide,
      nextSlide,
      toSlide,
    },
    data: _data,
  };
}



// WEBPACK FOOTER //
// ./src/uikit/components/AppDefaultLayout/components/parts/slider/carousel.ts